// Mirrors backend/models/SalesDocument.js STATUS_BY_DOC_TYPE — kept in sync
// manually since the frontend can't import a backend Mongoose model.
export const STATUS_BY_DOC_TYPE = {
  receipt: ["issued", "voided"],
  quotation: ["pending", "accepted", "expired", "rejected"],
  invoice: ["unpaid", "paid", "overdue", "cancelled"],
};
